module.exports = __webpack_public_path__ + "img/295.cf98c5f3.png";